module.exports = __webpack_public_path__ + "img/IV_red.b4302a49.png";